import { useState, useContext, useEffect, useCallback } from "react";
import utility from "src/utils/utility";
import ApiContext from "src/provider/API/call-service";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import {
  AbsoluteContainer,
  AppSpan,
  AppText,
  Button,
  CustomContainer,
  FlexRow,
  Form,
  FormGroupWithIcon,
  ScreenContainer,
} from "src/style";
import { explain } from "src/utils/view";
import ReactTooltip from "react-tooltip";
import helpers from "src/utils/helpers";
import { BsEyeSlash, BsEye } from "react-icons/bs";
import { OptionType, QoreStaffTypes } from "src/model";
import { FiChevronDown } from "react-icons/fi";

const BuildGeneration = () => {
  const { API } = useContext(ApiContext);
  const {
    info: { qoreStaffType },
  } = useContext(AppInfoContext);
  const [inputsDisabled, setInputsDisabled] = useState(false);

  const [userType, setUserType] = useState("");
  const [allInstitutions, setAllInstitutions] = useState<any>([]);
  const buildType = ["APK", "AAB"];
  const institutions: OptionType[] = allInstitutions.map(
    (institution: any) => ({ label: institution.name, value: institution.id })
  );

  const [input, setInput] = useState({
    institutionCode: "",
    buildType: "",
  });

  async function handleFetchInstitution() {
    const response = await API.getAllInstitutions();
    if (response?.length)
      setAllInstitutions(helpers.sortItemsWIthString(response, "name", "asc"));
  }

  useEffect(() => {
    handleFetchInstitution();
  }, []);

  useEffect(() => {
    if (qoreStaffType) {
      setUserType(qoreStaffType);

      if (qoreStaffType != QoreStaffTypes.DEVELOPER) {
        setInputsDisabled(true);
      }
    }
  }, [qoreStaffType]);

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) => {
      e.preventDefault();

      const response = await API.StartAndroidBuild(input.institutionCode,input.buildType);
      console.log("respBui", response);
    },
    [API, input]
  );

  const handleInput = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => setInput({ ...input, [e.target.name]: e.target.value });

  return (
    <>
      <AppText textSize="2.3" color="#101828" fontWeight="700" bottomMargin="1">
        Default Build Settings
      </AppText>
      <ScreenContainer>
        <Form onSubmit={handleSubmit}>
          <CustomContainer topMargin="2">
            <FlexRow gap="2">
              <FormGroupWithIcon>
                <label>Build Type</label>
                <div className="input-with-icon">
                  <select
                    name="buildType"
                    value={input.buildType}
                    onChange={handleInput}
                    autoComplete="off"
                    required
                  >
                    <option value="">Select build type</option>
                    {buildType.map((type: any, index: number) => (
                      <option key={index} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                  <FiChevronDown className="input-with-icon-tag" />
                </div>
              </FormGroupWithIcon>

              <FormGroupWithIcon>
                <label>Institution</label>
                <div className="input-with-icon">
                  <select
                    name="institutionCode"
                    value={input.institutionCode}
                    onChange={handleInput}
                    autoComplete="off"
                    required
                  >
                    <option value="">Select Institution</option>
                    {institutions.map((institution: any, index: number) => (
                      <option key={index} value={institution.value}>
                        {institution.label}
                      </option>
                    ))}
                  </select>
                  <FiChevronDown className="input-with-icon-tag" />
                </div>
              </FormGroupWithIcon>
            </FlexRow>
          </CustomContainer>
          {
            <FlexRow justifyContent="flex-end" gap="2" bottomMargin="3.5">
              <Button
                width="12"
                bgColor="#ffffff"
                titleSize="1.4"
                fontWeight="600"
                height="4"
                radius="0.8"
                color="#0D968F"
                hoverColor="#ffffff"
                hoverBgColor="#0D968F"
                borderColor="#0D968F"
              >
                Generate Build
              </Button>
            </FlexRow>
          }
        </Form>
      </ScreenContainer>
    </>
  );
};

export default utility.routeData(
  "build-generation",
  "Build Generation",
  <BuildGeneration />
);
